module.exports = __webpack_public_path__ + "assets/img/help_image04-3@2x.33a3ec9e.png";